
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from 'clsx';
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { TextField } from "@mui/material";
import { Row, Col, Image, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { checkViewPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { NavLink, Link, useParams } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import managementActions from "../../../Management/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { ListTable } from "./ListTable";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { AESEncrypt } from "../../../../../helpers/Crypto";


export default function DeliveryNote(props) {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const prevSearch = usePrevious(search);
    const [sortBy, setSortBy] = useState("createTs");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const timeoutRef = useRef(null);
    //const searchInput = useRef(null);
    let { invoiceOrderID } = useParams();
    const [customerId, setCustomerId] = useState('');
    const [customer, setCustomer] = useState({});
    const { history } = props;
    const [loadMore, setLoadMore] = useState(false);
    const [selected, setSelected] = useState([]);

    const [loadMoreContent, setLoadMoreContent] = useState(false);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFillter(customerId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    dispatchFillter(customerId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);


    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Delivery Note History', history, 'Sales')) {
                loadTasks();
                customerApi();
            }
        }
        return () => {
            dispatch({ type: managementActions.CLEAR_MANAGEMENT_DETAILS_START });
        }

    }, [roleManagement]);

    const loadTasks = useCallback(() => {
        dispatchFillter(customerId, sortBy, sortOrder);
    });

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFillter(customerId, sortBy, sortOrder, s);
    }

    const dispatchFillter = (customerId = '', sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (invoiceOrderID) {
            filter['and'].push({ salesOrderId: invoiceOrderID });
        }

        if (search) {
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customer_name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customer_email: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customer_phone: { like: '%' + search.trim() + '%' } });
            or['or'].push({ deliveryStatus: { like: '%' + search.trim() + '%' } });
        }

        if (customerId) {
            filter['and'].push({ customerId: customerId });
        }

        filter['and'].push(or);
        let f = {
            where: filter,
            order: sortBy + ' ' + sortOrder
        }

        if (!customerId) {
            f.limit = limit;
            f.skip = skip;
        }

        timeoutRef.current = null;
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'v1/sales-delivery/sales-deliveries',
            skip: skip,
            filter: f
        })
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (invoiceOrderID) {
            filter['and'].push({ salesOrderId: invoiceOrderID });
        }

        if (customerId !== '') {
            filter['and'].push({ customerId: customerId });
        }

        if (search !== '') {
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customer_name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customer_email: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customer_phone: { like: '%' + search.trim() + '%' } });
            or['or'].push({ deliveryStatus: { like: '%' + search.trim() + '%' } });
        }

        filter['and'].push(or);

        dispatch({
            type: crudActions.EXPORT_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'v1/sales-delivery/sales-deliveries',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFillter(customerId, sortBy, sortOrder);
    }

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: managementActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleChangeCustomer = (value) => {
        setCustomerId(value.id);
        setCustomer(value);
        dispatchFillter(value.id, sortBy, sortOrder);
    }

    const handleClick = (e, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };



    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader  {...props} cls={'newImg'}
                img={SalesIcon} title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Delivery Note History', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Delivery Note History'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Delivery Note History', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Delivery. No., Cus. Name, Cus. Email, Cus. Phone and, Status'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                onChange={(e) => setSearch(e.target.value)}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'deliveryNoteHistory', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={clsx(classes.vertiCalScrollOverFlow, classes.customFilterSalesDiscount)}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Delivery Note History', 'Action', 'All Customer') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Customers "}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={customerDetails}
                                                    customClasses={classes.customWidth172P}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    parentValue={customObject(customerDetails, customerId)}
                                                    id={idNamingConversion('All Customers', 'deliveryNoteHistory', 'DropDown')}
                                                    searchType={(s) => customerApi(s)}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            setCustomerId('');
                                                            setCustomer({});
                                                            dispatchFillter('', sortBy, sortOrder);
                                                        }
                                                    }}
                                                    onChange={(data) => handleChangeCustomer(data)}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Delivery Note History', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'deliveryNoteHistory', 'Link')}
                                                    onClick={() => { loadImportExportData('DeliveryNoteHistory'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Delivery Note History', 'Action', 'Create Invoice') && selected?.length > 0 &&
                                                <Link to={`/sales/transactions/delivery-note/${AESEncrypt(
                                                    {
                                                        name: customer?.name || '',
                                                        phone: customer?.mobile || '',
                                                        email: customer?.email || '',
                                                        deliveryIds: selected,
                                                        single: false
                                                    })}/invoice`} className={clsx(classes.modalBtn, classes.marginRight0)} id={idNamingConversion('CreateInvoice', 'deliveryNoteHistory', 'Link')}>Create Invoice</Link>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                customerId={customerId}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadTasks={() => dispatchFillter(customerId, sortBy, sortOrder)}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                roleManagement={roleManagement}
                                handleClick={(e, id) => handleClick(e, id)}
                                selected={selected}
                                onSelected={(value) => setSelected(value)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}

                            />
                        </>
                    }
                />
            </div>
        </Fragment>
    )

}